var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.floorName),expression:"floorName"}],attrs:{"id":"title"}},[_c('span',{staticClass:"border"},[_vm._v(" ")]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.floorName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }